var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"trading-list-view"},[_c('h1',[_vm._v(" "+_vm._s(_vm.$t("trading.title"))+" ")]),_c('div',[_c('MySellOffersList',{attrs:{"isLoading":_vm.loading,"projects":_vm.projects}})],1),_c('div',[_c('TradingList',{attrs:{"isLoading":_vm.loading,"projects":_vm.projects}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }